module.exports = __webpack_public_path__ + "img/tandoori-chicken-with-herb-yoghurt-sauce.7db7b3dc.jpg";